import { Component, OnInit } from '@angular/core';
import { BaseDashboardHeaderComponent } from './base-dashboard-header.component';
import { ICONS, IDashboardExtraIcon } from '../dashboard.model';

@Component({
  selector: 'lbdm-dashboard-header',
  template: `
    <div class="header-info">
      <div class="triple-space-bottom">
        <faq-link faqCode="BUSINESS_PRACTICE_GUIDELINES"></faq-link>
      </div>
      <collapsible-pane title="Status icon information">
        <ul>
          <li *ngFor="let icon of icons">
            <i [ngClass]="icon.classes"></i>
            {{icon.legend}}
          </li>
        </ul>
      </collapsible-pane>
    </div>
  `
})
export class LbdmDashboardHeaderComponent extends BaseDashboardHeaderComponent implements OnInit {
  public icons:IDashboardExtraIcon[];

  public ngOnInit():void {
    this.icons = ICONS;
  }
}